import React from "react";

const LeftDrawerContent = ({ title, children, searchProps }) => {

  return (
    <React.Fragment>

      {children}
    </React.Fragment>
  );
};

export default LeftDrawerContent;
